(function() {
  let isFetching = false;
  let inStockProducts = [];
  let outOfStockProducts = [];
  let nextUrl = null;
  let totalCount = 0;
  let visibleCount = 0;
  let pageSize = 24;

  function initLoadMore() {
    const wrapper = document.querySelector('.collection-grid-wrapper');
    const loadMoreBtn = document.querySelector('.load-more-btn');
    const spinner = document.querySelector('.load-more-spinner');
    const listContainer = document.querySelector('.collection-listing-loadmore');
    const countSummary = document.getElementById('ProductCountSummary');

    if (!wrapper || !listContainer || !loadMoreBtn) return;

    // Discard old event listeners by replacing the button with a clone
    const cleanBtn = loadMoreBtn.cloneNode(true);
    loadMoreBtn.parentNode.replaceChild(cleanBtn, loadMoreBtn);

    // Reset state for new page load / AJAX reload
    inStockProducts = [];
    outOfStockProducts = [];
    nextUrl = listContainer.getAttribute('data-next-url') || null;
    totalCount = countSummary ? parseInt(countSummary.getAttribute('data-count')) || 0 : 0;
    
    // Read initial products from the DOM
    const initialItems = Array.from(wrapper.children);
    pageSize = initialItems.length || 24;
    visibleCount = pageSize;

    initialItems.forEach(item => {
      if (item.classList.contains('product-card--soldout')) {
        outOfStockProducts.push(item);
      } else {
        inStockProducts.push(item);
      }
    });

    // Update the counter
    function updateCountSummary() {
      if (!countSummary) return;
      const currentVisible = wrapper.querySelectorAll('.grid__item').length;
      const showing = Math.min(currentVisible, totalCount);
      countSummary.textContent = 'Showing 1 - ' + showing + ' Of ' + totalCount + ' Item(S)';
    }

    // Function to render products up to target visibleCount
    function render() {
      wrapper.innerHTML = '';
      const allSorted = inStockProducts.concat(outOfStockProducts);
      const toShow = allSorted.slice(0, visibleCount);
      toShow.forEach(item => wrapper.appendChild(item));
      updateCountSummary();

      // Re-initialize Quick Shop modal triggers for newly rendered products
      if (window.theme && typeof window.theme.initQuickShop === 'function') {
        window.theme.initQuickShop();
      }

      // Show or hide Load More button
      const totalLoaded = allSorted.length;
      if (nextUrl || visibleCount < totalLoaded) {
        cleanBtn.style.display = 'inline-block';
      } else {
        cleanBtn.style.display = 'none';
      }
    }

    // Fetch next page and extract products
    async function fetchNextPage() {
      if (!nextUrl) return;
      const res = await fetch(nextUrl);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newWrapper = doc.querySelector('.collection-grid-wrapper');
      if (newWrapper) {
        const newItems = Array.from(newWrapper.children);
        newItems.forEach(item => {
          if (item.classList.contains('product-card--soldout')) {
            outOfStockProducts.push(item);
          } else {
            inStockProducts.push(item);
          }
        });
      }

      const nextEl = doc.querySelector('.collection-listing-loadmore');
      nextUrl = nextEl ? nextEl.getAttribute('data-next-url') : null;
    }

    // Ensure we have enough in-stock products to show (or nextUrl is empty)
    async function fillInStock(targetCount) {
      while (inStockProducts.length < targetCount && nextUrl) {
        await fetchNextPage();
      }
    }

    // Initialize display:
    if (spinner) spinner.style.display = 'block';
    cleanBtn.style.display = 'none';

    fillInStock(visibleCount).then(() => {
      if (spinner) spinner.style.display = 'none';
      render();
    });

    // Save scroll position when navigating to a product
    if (!wrapper.dataset.bound) {
      wrapper.dataset.bound = "true";
      wrapper.addEventListener('click', function (e) {
        const productLink = e.target.closest('a[href*="/products/"]');
        if (productLink) {
          sessionStorage.setItem('collectionScrollPos', window.scrollY);
        }
      });
    }

    // --- Load More button ---
    cleanBtn.addEventListener('click', async function (e) {
      e.preventDefault();
      if (isFetching) return;

      isFetching = true;
      cleanBtn.style.display = 'none';
      if (spinner) spinner.style.display = 'block';

      visibleCount += pageSize;

      try {
        // Fetch more in-stock products in the background if we don't have enough
        await fillInStock(visibleCount);
        render();
      } catch (err) {
        console.error('Load more failed:', err);
        cleanBtn.style.display = 'inline-block';
      }

      if (spinner) spinner.style.display = 'none';
      isFetching = false;
    });
  }

  // Run on initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLoadMore);
  } else {
    initLoadMore();
  }

  // Run after AJAX reloads (Shopify themes fire these events)
  document.addEventListener('page:loaded', initLoadMore);
  document.addEventListener('shopify:section:load', initLoadMore);
  document.addEventListener('collection:reloaded', initLoadMore);

  // Handle back/forward cache (bfcache)
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    const scrollPosition = sessionStorage.getItem('collectionScrollPos');
    if (scrollPosition) {
      requestAnimationFrame(function () {
        window.scrollTo({ top: parseInt(scrollPosition), behavior: 'instant' });
        sessionStorage.removeItem('collectionScrollPos');
      });
    }
    const spinner = document.querySelector('.load-more-spinner');
    if (spinner) spinner.style.display = 'none';
  });
})();
